import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-globe',
  templateUrl: './icon-globe.component.html',
  styleUrls: ['./icon-globe.component.scss']
})
export class IconGlobeComponent implements OnInit {
  @Input() color: string = '#D0D0D0';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
